export default __webpack_public_path__ + "static/media/nord-west.cc40f9dc.svg";